import React from 'react';
import './Footer.css';
import { PROJECT_DISPLAY_NAME } from '../../config/apiConfig';

export default function Footer() {
  return (
    <div className="footer">
    <div className="footer-inner">
      <div className="footer-content">
        <span className="font14">
          <span className="blue bolder">MarketsandMarkets</span>
          &nbsp;{PROJECT_DISPLAY_NAME} © 2024-2025
        </span>

      </div>
    </div>
  </div>
  )
}
